module.exports = __webpack_public_path__ + "static/media/4-2-na-nebe-vstoupil.240ce2be.jpg";